import {
  Geofence_Data,
  GeofenceTrigger_LocationHistory_Read_Nested,
  GeofenceTrigger_Read,
  GeofenceTriggerType,
} from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

import { DriverMinimal } from '~hooks/useDrivers/models';
import { EquipmentMinimal } from '~hooks/useEquipment/models';
import { JobMinimal } from '~hooks/useJob/models';
import { OrderMinimal } from '~hooks/useOrders/models';
class GeofenceTriggerLocationHistoryBasic {
  constructor(
    private _id: string,
    private _lat: string,
    private _lon: string,
    private _occurredAt: Dayjs,
    private _driver: DriverMinimal | null,
    private _equipment: EquipmentMinimal | null,
    private _order: OrderMinimal | null,
    private _job: JobMinimal | null,
  ) {}

  public get id() {
    return this._id;
  }

  public get lat() {
    return this._lat;
  }

  public get lon() {
    return this._lon;
  }

  public get occurredAt() {
    return this._occurredAt;
  }

  public get driver() {
    return this._driver;
  }

  public get equipment() {
    return this._equipment;
  }

  public get order() {
    return this._order;
  }

  public get job() {
    return this._job;
  }

  public static parse(proto: GeofenceTrigger_LocationHistory_Read_Nested) {
    return new GeofenceTriggerLocationHistoryBasic(
      proto.id,
      proto.lat,
      proto.lon,
      dayjs(proto.occurred_at),
      proto.driver ? DriverMinimal.parse(proto.driver) : null,
      proto.equipment ? EquipmentMinimal.parse(proto.equipment) : null,
      proto.order ? OrderMinimal.parse(proto.order) : null,
      proto.job ? JobMinimal.parse(proto.job) : null,
    );
  }
}

class GeofenceDataGeofence {
  constructor(
    private _name: string,
    private _type: string,
    private _circleCenter: { lat: number; lon: number } | null,
    private _circleRadius: number | null,
    private _geojsonCoordinates: unknown[][][] | null,
  ) {}

  public get name() {
    return this._name;
  }

  public get type() {
    return this._type;
  }

  public get circleCenter() {
    return this._circleCenter;
  }

  public get circleRadius() {
    return this._circleRadius;
  }

  public get geojsonCoordinates() {
    return this._geojsonCoordinates;
  }

  public static parse(proto: NonNullable<Geofence_Data['geofence']>) {
    return new GeofenceDataGeofence(
      proto.name,
      proto.type,
      proto.circle_center ?? null,
      proto.circle_radius ?? null,
      proto.geojson?.coordinates ?? null,
    );
  }
}

class GeofenceData {
  constructor(
    private _id: string | null,
    private _geofence: GeofenceDataGeofence | null,
    private _tag: string | null,
  ) {}

  public get id() {
    return this._id;
  }

  public get geofence() {
    return this._geofence;
  }

  public get tag() {
    return this._tag;
  }

  public static parse(proto: Geofence_Data) {
    return new GeofenceData(
      proto.id ?? null,
      proto.geofence ? GeofenceDataGeofence.parse(proto.geofence) : null,
      proto.tag ?? null,
    );
  }
}

export class GeofenceTrigger {
  constructor(
    private _triggerType: GeofenceTriggerType,
    private _triggeredLocation: GeofenceTriggerLocationHistoryBasic,
    private _geofence: GeofenceData,
  ) {}

  public get triggerType() {
    return this._triggerType;
  }

  public get triggeredLocation() {
    return this._triggeredLocation;
  }

  public get geofence() {
    return this._geofence;
  }

  public static parse(proto: GeofenceTrigger_Read) {
    return new GeofenceTrigger(
      proto.geofence_trigger_type,
      GeofenceTriggerLocationHistoryBasic.parse(proto.triggered_location),
      GeofenceData.parse(proto.geofence),
    );
  }
}
